<template>
  <div class="pubMedChart">
    <viewHeader></viewHeader>
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <el-card class="box-card" shadow="never" v-show="hasData">
        <div slot="header" class="clearfix">
          <el-row>
            <el-col :span="searchType == 'clinical_search'? 16 : 19">
              <img src="../assets/img/icon0.png" alt="" class="L" />
              <span class="L">{{ title_word }}<span style="margin-left: 0" v-show="searchType == 'similarly_clinical'">的相似研究</span></span>
              
            </el-col>
            <el-col :span="5" class="searchInput">
              分析前
              <el-input size="small" v-model="num_summary" :readonly="searchType == 'similarly_clinical'"></el-input> 项研究
            </el-col>
            <el-col :span="3" v-show="searchType == 'clinical_search'">
              <el-button
                class="R searchButton"
                size="small"
                type="text"
                @click="handleAnalysis"
                >分析</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="introduce" v-show="hasFenxi">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">研究分析</em>
          </h2>
          <el-tabs type="border-card">
            <el-tab-pane
              :label="item.section_name"
              lazy
              v-for="(item, index) in chart"
              :key="'tab' + index"
            >
              <span slot="label" style="position: relative">
                {{ item.section_name }}
              </span>
              <ol class="bullet_point">
                <li
                  v-for="(point, pointIndex) in item.bullet_points"
                  :key="'point' + pointIndex"
                  class="clearfix"
                >
                  <span class="L"></span>
                  <em class="L">{{ point }}</em>
                </li>
              </ol>
              <template>
                <div
                  v-for="(chart, chartIndex) in item.charts"
                  :key="'bar' + chartIndex"
                >
                  <p class="keyType">
                    {{ chart.chart_title }}
                  </p>
                  <ve-bar
                    v-if="chart.chart_type == 'bar'"
                    :data="chart.chartData"
                    :extend="chartExtend"
                    :legend-visible="false"
                  >
                  </ve-bar>
                  <ve-ring 
                  v-if="chart.chart_type == 'ring'"
                  :data="chart.chartData"
                  :legend-visible="false"
                  :settings="{ radius: [70, 150]}"
                  ></ve-ring>
                  <ve-line
                  v-if="chart.chart_type == 'line'"
                  :data="chart.chartData"
                  :legend-visible="false"
                  :extend="{
                    color: '#75a1f7',
                    xAxis:{name: chart.xlab,nameGap: 28},
                  }"
                  :settings="{area: true,yAxisName: [chart.ylab],xAxisType: 'value',digit: 10}"
                  ></ve-line>
                  <ve-line
                    v-if="chart.chart_type == 'muti_line'"
                    :data="chart.chartData"
                    :legend-visible="true"
                    :settings="{dimension: [chart.xlab]}"
                  ></ve-line>
                  <ve-wordcloud
                    v-if="chart.chart_type === 'wordcloud'"
                    :data="chart.chartData"
                    :events="wordCloudEvents(chart.chart_title)"
                  >
                  </ve-wordcloud>
                  <!-- 旭日图 -->
                  <Sunburst v-if="chart.chart_type === 'sunburst'" :chartData="chart.data"></Sunburst>
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，没有找到需要分析的研究哦~</span>
      </div>
    </div>
  </div>
</template>

<script>
import { md5 } from "md5js";
import { translateInfo, trialAnalysis } from "../service/getData";
import viewHeader from "./viewHeader";
import Sunburst from '../components/Sunburst'
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "trialAnalysis",
  components: {
    viewHeader,
    Sunburst
  },
  data() {
    this.chartSettings = {
      // dimension: ['年份'],
      // metrics: ['文章数'],
    };
    return {
      hasData: true,
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true,
      reverse: false,
      color: "#3cabd5",
      timeData: {},
      chart: [],
      chartExtend: {
        color: "#75a1f7",
        series: {
          // barWidth: 20,
          barMaxWidth: 20,
          // barGap: '30%'
          // label:{ show: true }
        },
      },
      searchType: "", // 分析文献的类型
      keyword: "",
      summaryLimted: 1000,// 总结的上限，研究：1000，相似研究： 200
      num_summary: 1000,
      registration: "",
      filter: {},
      title_word: "",
      titleJson: {},
      hasFenxi: true, // 是否存在文献分析
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      currentPageUrl: '', // 当前页面url
    }
  },
  methods: {
    // 修改分析数量后进行分析
    handleAnalysis() {
      if(isNaN(this.num_summary) || Number(this.num_summary) > this.summaryLimted) {
        this.num_summary = this.summaryLimted;
      }
      this.getAnalysis();
      

    },
    // 文献分析总结
    async getAnalysis() {
      this.loading = true;
      const params = {
        filters: this.filter,
        method:  ["概览", "设计", "PICO", "机构", "成果"],
        search_type: this.searchType
      };
      if(this.searchType == 'clinical_search') {
        params.keyword = this.keyword;
        params.numFound = Number(this.num_summary)
      }
      if(this.searchType == 'similarly_clinical') {
        params.registration = this.registration
      }

      const res = await trialAnalysis(params);
      this.loading = false
      if (res && res.data.status === 0) {
        if (res.data.study_summary) {
          this.hasFenxi = true;
          res.data.study_summary.forEach((item) => {
            if (item.charts) {
              item.charts.forEach((items) => {
                items.chartData = {};
                if (items.chart_type === "wordcloud") {
                  items.chartData["rows"] = items.data;
                  items.chartData["columns"] = ["name", "value"];
                } else if(items.chart_type == "bar") {
                  items.chartData["rows"] = items.data;
                  items.chartData["columns"] = [items.xlab, items.ylab];
                } else if(items.chart_type == "ring") {
                  items.chartData["rows"] = items.data;
                  items.chartData["columns"] = ['name','value'];
                } else if(items.chart_type == "line") {
                  const { xlab, ylab, data } = items;
                  items.chartData["rows"] = items.data.map(point => {
                    return {
                      [xlab]: parseInt(point[0]),
                      [ylab]: point[1]
                    }
                  });
                  items.chartData["columns"] = [xlab,ylab];
                } else if(items.chart_type == 'muti_line') {
                  const { chart_title } = items;
                  if(chart_title == '研究类型逐年变化趋势') {
                    const result = {};
                    const data_list = items.data.map(item => {
                      const type = item["研究类型"];
                      const value = item["研究数"];
                      return {
                        "注册年份": String(item["注册年份"]),
                        [type]: value
                      }
                    });
                    data_list.forEach(item => {
                      const year = item["注册年份"];
                      const isExist = result[year];
                      if (isExist) {
                        result[year] = {
                          ...result[year],
                          ...item
                        }
                      } else {
                        result[year] = item;
                      }
                    });
                    items.chartData["rows"] = Object.values(result);
                    items.chartData["columns"] = Object.keys(Object.values(result)[0]);
                  }
                   if(chart_title == '时间视角逐年变化趋势') {
                    const result = {};
                    const data_list = items.data.map(item => {
                      const type = item["时间视角"];
                      const value = item["研究数"];
                      return {
                        "注册年份": String(item["注册年份"]),
                        [type]: value
                      }
                    });
                    data_list.forEach(item => {
                      const year = item["注册年份"];
                      const isExist = result[year];
                      if (isExist) {
                        result[year] = {
                          ...result[year],
                          ...item
                        }
                      } else {
                        result[year] = item;
                      }
                    });
                    items.chartData["rows"] = Object.values(result);
                    items.chartData["columns"] = Object.keys(Object.values(result)[0]);
                  }
                }
              })
            }
          });
          this.chart = res.data.study_summary;

          // log
          let Logger = webTrackerEvent();
          Logger.push("action", "ClinicalTrialSummary");
          Logger.push("params", JSON.stringify(params));
          Logger.push("searchText", params.keyword);
          Logger.push("pmid", params.registration);
          Logger.push("timeStamp", new Date().getTime());
          Logger.push("token", this.token);
          Logger.push("openid", this.openid);
          Logger.push("pageUrl", window.location.href);
          Logger.logger();
        } else {
          this.hasFenxi = false;
        }
      } else {
        this.loading = false;
        this.num_summary = "";
        this.num_overview = "";
        this.hasData = false;
      }
    },
    /**
     * 热点研究词云图点击
     */
    wordCloudEvents(title) {
      if(title == '热点研究') {
        return {
          click: (e)=> {
            const { name: registration } = e.data;
            if(registration) {
              const { href } = this.$router.resolve({
                name: "trialDetail",
                path: "/trialDetail",
                query: {
                  registration: registration,
                  searchType: "clinical"
                },
              });
              window.open(href);
            }
          }
        }
      } else {
        return;
      }
    },
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("action", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  mounted() {
    const { keyword,numFound,filter,type,registration,searchType } = this.$route.query;
    this.registration = registration;
    this.keyword = keyword;
    this.numFound = Number(numFound);
    this.filter = JSON.parse(filter);
    this.searchType = type;
    this.title_word = keyword || registration;
    if(type == 'similarly_clinical') {
      this.summaryLimted = 200;
      this.num_summary = 200;
    } else {
      this.summaryLimted = 1000;
      this.num_summary = 1000;
    }


    this.currentPageUrl = window.location.href;
    let Logger = webTrackerEvent();
    Logger.push("action", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();

    this.getAnalysis();
  },
};
</script>

<style scoped lang="less">
.pubMedChart {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}
.pubMedChart .content {
  width: 1080px;
  margin: 0 auto;
}
.pubMedChart .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-top: 10px;
}
.pubMedChart .content .el-card__header span em {
  font-size: 14px;
  color: #333;
  font-weight: normal;
}
.pubMedChart .content .el-card__header img {
  margin-top: 10px;
}
.pubMedChart .content .el-card .actualNum {
  margin-bottom: 10px;
  font-size: 13px;
  color: #333;
}
.pubMedChart .content .el-card .actualNum span {
  color: #336098db;
}
.content .introduce {
  margin-bottom: 40px;
}
.content .introduce h2.title {
  font-weight: normal;
  font-size: 16px;
  color: #333;
}
.content .introduce h2.title span {
  width: 6px;
  height: 24px;
  background: #4083d4;
  display: block;
}
.content .introduce h2.title em {
  margin-left: 10px;
  line-height: 24px;
}
.content .searchInput {
  font-size: 16px;
  color: #333;
}
.content .searchInput .el-input {
  width: 80px;
  margin-top: 5px;
  border: none;
  border: 1px solid #153d85;
  border-radius: 5px;
}
.content .searchButton {
  background: #387ed2;
  padding: 10px 40px;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
}
.content .introduce .info {
  line-height: 30px;
  margin-top: 10px;
}
.content .medInfo .el-row {
  border-bottom: 1px dashed #e2e2e2;
}
.content .medInfo .el-row .el-col {
  line-height: 40px;
}
.content .medInfo .el-row .el-col span {
  font-weight: bold;
}
.content .introduce .el-tabs {
  margin-top: 20px;
}
.content .introduce .el-badge {
  top: 0;
}
.pubMedChart .content .resultList ul li.infoLi {
  border-bottom: 1px dashed #ccc;
  margin-top: -1px;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.pubMedChart .content ul li.el-timeline-item {
  padding: 0;
  border: none;
  margin-bottom: 30px;
  margin-top: 20px;
  /* overflow:visible; */
}
.pubMedChart .content .resultList ul li.el-timeline-item p.timeLine {
  font-size: 14px;
  color: #333;
  padding-left: 24px;
  background: url("../assets/img/chart2.png") no-repeat 0 center;
  margin-bottom: 10px;
  height: 18px;
  line-height: 18px;
}
.pubMedChart .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.pubMedChart .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.pubMedChart .content .resultList .listInfo {
  margin-top: 10px;
}
.pubMedChart .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.pubMedChart .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.pubMedChart .content .resultList .el-col .showMore {
  margin-left: 10px;
  display: block;
  font-size: 14px;
  line-height: 30px;
}
.pubMedChart .content .resultList .el-col .translate {
  margin-left: 10px;
  display: block;
  font-size: 14px;
  line-height: 30px;
}
.pubMedChart ol.bullet_point li {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
}
.pubMedChart ol.bullet_point li span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #000;
  display: block;
  margin-top: 6px;
}
.pubMedChart ol.bullet_point li em {
  margin-left: 10px;
  width: 90%;
  line-height: 20px;
}
.pubMedChart .introduce p.keyType {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.pubMedChart .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pubMedChart .noData img {
  display: block;
  margin: 0 auto;
}
.pubMedChart .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
.pubMedChart .progressBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}
.pubMedChart .progressBox .shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(31, 31, 31, 0.7);
}
.pubMedChart .gender-district-box{
  ul{
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    li{
      width: 33%;
      padding: 20px 0;
      display: flex;
      align-items: center;
      background: #fff;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
      box-shadow: 0 2px 6px rgba(0, 73, 125, .2);
      // border: 1px solid #49b1d8;
      margin-right: 24px;
      border-radius: 10px;
      justify-content: center;
      img{
        width: 60px;
        height: 70px;
      }
      .num-message{
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        span{
          font-size: 14px;
          color: #606266;
        }
        em{
          font-size: 30px;
          color: #333;
          margin-top: 4px;
          font-weight: bold;
        }
      }
      &:last-child{
        margin: 0;
      }
    }
  }
  .gender-analysis-box{
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    height: 400px;
    .analysis-box{
      flex: 1;
      height: 100%;
      background: #fff;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
      box-shadow: 0 2px 6px rgba(0, 73, 125, .2);
      margin-right: 24px;
      border-radius: 10px;
      color: #333;
      h3{
        padding: 16px 24px;
        border-bottom: 1px solid #E9E9E9;
        font-size: 16px;
      }
      &:last-child{
        margin: 0;
      }
    }
  }
}
</style>
<style>
.content .introduce .el-tabs--border-card > .el-tabs__header {
  background-color: #f5fcff;
  border-bottom-color: #49b1d8;
  margin-left: 1px;
}
.content .introduce .el-tabs--border-card {
  box-shadow: none;
  border: 1px solid #49b1d8;
  border-right: none;
  border-left: none;
  border-top: none;
}
.content
  .introduce
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  border-right-color: #49b1d8;
  border-left-color: #49b1d8;
  border-top-color: #49b1d8;
  border-bottom: none;
}
.content .introduce .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border-bottom-color: #49b1d8;
  color: #333;
  font-weight: normal;
}
.content .introduce .el-tabs--border-card > .el-tabs__content {
  border-right: 1px solid #49b1d8;
  border-left: 1px solid #49b1d8;
}
.content .introduce .el-tabs__nav {
  float: none;
}
.content .introduce .el-tabs__nav-wrap {
  overflow: visible;
}
.content .introduce .el-tabs__nav-scroll {
  overflow: visible;
}
/* .pubMedChart .content ul li.el-timeline-item .el-timeline-item__wrapper{
    padding: 0 !important
} */
/* .pubMedChart .content .el-timeline-item__node--normal{
    left:-21px;
}*/
.pubMedChart .content .el-timeline-item__tail {
  height: 105%;
  border: 1px solid #56b6db;
}
.pubMedChart .progressBox .el-progress .el-progress-bar {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/views/trialAnalysis.vue